// extracted by mini-css-extract-plugin
module.exports = {"main":"Navigation_main__2i9Ah","background":"Navigation_background__2rmRW","title":"Navigation_title__195gD","icon":"Navigation_icon__2daN4"};